module.exports = __webpack_public_path__ + "img/Z60_15.2dc7c5dd.jpg";